// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

$w.onReady(function () {

$w('#button1').onClick((event) => {saveItem()})

function saveItem(){


}
});